export const ScheduleDetails = ({
    appTheme,
    totalDuration,
    totalVideoDuration,
    totalAdDuration,
    totalPromosDuration
}) => {
    return (
        <div className="schedule-details col-10">
            <div>
                <table className={`table borderless ${appTheme === "light"? "border":""}`}>
                    <thead>
                        <tr>
                            <th className="border-0" style={{borderTopLeftRadius: "6px"}}>Total scheduled</th>
                            <th className="text-center border-0">Number</th>
                            <th className="text-center border-0" style={{borderTopRightRadius: "6px"}}>HH:MM:SS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="d-flex align-items-center"><input class="checkbox-for-table me-1" type="checkbox" value="" id="flexCheckDefault" checked/>Total Scheduled</td>
                            <td className="text-center">{totalDuration?.totalNum}</td>
                            <td className="text-center">{totalDuration?.duration}</td>
                        </tr>
                        <tr>
                            <td className="d-flex align-items-center"><input class="checkbox-for-table me-1" type="checkbox" value="" id="flexCheckDefault" checked/>Videos</td>
                            <td className="text-center">{totalVideoDuration?.totalNum}</td>
                            <td className="text-center">{totalVideoDuration?.duration}</td>
                        </tr>
                        <tr>
                            <td className="d-flex align-items-center"><input class="checkbox-for-table me-1" type="checkbox" value="" id="flexCheckDefault" checked/>Ads</td>
                            <td className="text-center">{totalAdDuration?.totalNum}</td>
                            <td className="text-center">{totalAdDuration?.duration}</td>
                        </tr>
                        <tr>
                            <td className="d-flex align-items-center pb-3" style={{borderBottomLeftRadius: "6px"}}><input class="checkbox-for-table me-1" type="checkbox" value="" id="flexCheckDefault" checked/>Promos</td>
                            <td className="text-center pb-3">{totalPromosDuration?.totalNum}</td>
                            <td className="text-center pb-3" style={{borderBottomRightRadius: "6px"}}>{totalPromosDuration?.duration}</td>
                        </tr>
                        {/* <tr>
                            <td>Secondary</td>
                            <td className="text-center">0</td>
                            <td className="text-center">00:00:00</td>
                        </tr> */}
                    </tbody>
                </table>
            </div>
        </div>
    )
}